import { RESET_STATE } from "@/stores/CommumActionTypes";
import {
	DELETE_RULE, SET_RULE, SET_MODE
} from "./StratificationActionType";

const mutations = {
	[SET_RULE]: (state, rule) =>
	{
		state.rules.push(rule);
	},
	[SET_MODE]: (state, mode) =>
	{
		state.mode = mode;
	},
	[DELETE_RULE]: (state, index) =>
	{
		state.rules.splice(index, 1);
	},
	[RESET_STATE]: (state) =>
	{
		state.rules = [];
	},
};

export default { mutations };
